import { render, staticRenderFns } from "./family-info.vue?vue&type=template&id=3461adee&scoped=true&"
import script from "./family-info.vue?vue&type=script&lang=js&"
export * from "./family-info.vue?vue&type=script&lang=js&"
import style0 from "./family-info.vue?vue&type=style&index=0&id=3461adee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3461adee",
  null
  
)

export default component.exports